// On phones a slim bar with the product names sticks just below the site header while the comparison rows
// scroll past. The header's height varies with the announcement bar and screen size, so the offset follows it.
class BarrierProductCompare extends HTMLElement {
  connectedCallback() {
    const header = document.getElementById('header-group');
    const bar = this.querySelector('.bw-compare-bar');
    const body = this.querySelector('tbody');
    if (!header || !bar || !body || this.resizeObserver) return;

    const phone = matchMedia('(max-width: 749px)');
    let offset = 0;
    let frame = 0;
    const updateOffset = () => {
      offset = Math.round(header.getBoundingClientRect().height);
      this.style.setProperty('--bw-compare-sticky-top', `${offset}px`);
      updateBar();
    };
    // The bar shows once the product row has scrolled under the header and hides as the buy buttons arrive.
    const updateBar = () => {
      frame = 0;
      if (!phone.matches) return this.classList.remove('is-stuck');
      const rows = body.getBoundingClientRect();
      this.classList.toggle('is-stuck', rows.top < offset && rows.bottom > offset + bar.offsetHeight);
    };
    this.onScroll = () => { frame ||= requestAnimationFrame(updateBar); };

    this.resizeObserver = new ResizeObserver(updateOffset);
    this.resizeObserver.observe(header);
    // Capture also catches Horizon's desktop .page-wrapper scroll container.
    document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
    document.removeEventListener('scroll', this.onScroll, { capture: true });
  }
}

if (!customElements.get('barrier-product-compare')) customElements.define('barrier-product-compare', BarrierProductCompare);
